import { get, ENDPOINTS } from "../../../services/checkout";

const fetchAccessToken = async (payload) => {
  try {
    if (!payload?.shop || !payload?.code || !payload.hmac || !payload?.state) {
      throw new Error("invalid-token-request");
    }

    const response = await get({
      endpoint: ENDPOINTS.SHOPIFY_TOKEN,
      params: payload,
    });

    return response;
  } catch (err) {
    return { error: err.message };
  }
};

export default fetchAccessToken;
